<template>
  <div class="solid_component">
    <div class="solid_chart">
      <div class="chart_div" ref="chart"></div>
      <div class="chart_start">0</div>
      <div class="chart_end">{{maxStep}}</div>
      <div class="chart_step">
        <div><span style="font-weight: 600;font-size: .30rem;">{{alreadyStep}}</span><span style="font-size: .10rem;color: #75787D;">步</span></div>
        <div style="font-size: .12rem;">宝贝今天已经步行</div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Highcharts from 'highcharts'

export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    maxStep: {
      type: Number,
      default:7000
    },
    alreadyStep:{
      type: Number,
      default:2000
    },

    borderWidth: {
      type: Number,
      default:0
    },
    startAngle: {
      type: Number,
      default: -90
    },
    endAngle: {
      type: Number,
      default: 90
    }
  },

  created(){

  },
  mounted () {
    this.chart = Highcharts.chart(this.$refs.chart, {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: 'transparent',
        height: 200,
        
      },
      tooltip: {
            enabled: false // 禁用提示框
          },
      exporting: {
                enabled:false
            },
      title: {
        text: null
      },
      credits: {
        enabled: false
      },

      
      plotOptions: {
        pie: {
          startAngle: this.startAngle,
          endAngle: this.endAngle,
          dataLabels: {
            enabled: false
          },
          states: {
            hover: {
              enabled: false
            }
          },
          borderWidth: this.borderWidth,
          borderRadius: 50,
          innerSize: '85%',
          size: '128%',
          borderColor: '#E0E0E0'
          
        }
      },
      series: [{
        type: 'pie',
        name: 'Progress',
        borderRadius: 5,
        data: [{
          y: this.value,
          color: '#0075FF',
          borderRadius: 5
        }, {
          y: 100 - this.value,
          color: '#5FA8FF',
          states: {
            hover: {
              enabled: false
            }
          }
        }]
      }]
    })
  },
  watch: {
    value (newVal) {
      if (this.chart) {
        this.chart.series[0].setData([{
          y: newVal,
          color: '#0075FF'
        }, {
          y: 100 - newVal,
          color: '#5FA8FF',
          states: {
            hover: {
              enabled: false
            }
          }
        }])
      }
    },
    borderWidth (newVal) {
      if (this.chart) {
        this.chart.series[0].update({
          borderWidth: newVal
        })
      }
    }
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
</script>
<style lang="scss">
.solid_component{
  .solid_chart{
    position: relative;
    top: 0.25rem;

    .chart_div{
      position: absolute;
      width: 100%;
      top: -0.25rem;
    }
    .chart_start{
      position: absolute;
      left: 0.68rem;
      top: 0.7rem;
    }
    .chart_end{
      position: absolute;
      left: 2.63rem;
      top: 0.7rem;
    }
    .chart_step{
      text-align: center;
      position: absolute;
      left: 1.2rem;
      top: 0.4rem;
    }
  }
}
</style>